import { route, tag, type PageTour } from '../pageTour';

export const cameraDetailTour: PageTour = {
  id: 'page-camera-detail',
  version: 1,
  title: 'Camera',
  summary: 'One camera: live view, recent events and status.',
  match: route('/nodes/:nodeId/cameras/:cameraId'),
  steps: [
    {
      target: tag('camera-detail-recordings'),
      title: 'Recordings',
      description: 'Jump straight to recorded footage from this camera.',
      side: 'bottom',
      permission: 'recordings.view',
    },
    {
      target: tag('camera-detail-heatmap'),
      title: 'Heatmap',
      description: 'See where people spend the most time in this camera\'s view.',
      side: 'bottom',
    },
    {
      target: tag('camera-detail-edit'),
      title: 'Edit camera',
      description: 'Change the camera\'s name, location, stream address or groups.',
      side: 'bottom',
      permission: 'cameras.edit',
    },
    {
      target: tag('camera-detail-player'),
      title: 'Live view',
      description: 'The camera\'s live feed. If it stalls, use the retry button on the player.',
      side: 'right',
    },
    {
      target: tag('camera-detail-info'),
      title: 'Camera details',
      description: 'The camera\'s address, make, model, location and the groups it belongs to.',
      side: 'left',
    },
    {
      target: tag('camera-detail-recording-config'),
      title: 'Recording settings',
      description: 'Choose when this camera records — always, on motion or on events — and how long footage is kept.',
      side: 'top',
      permission: 'recordings.view',
    },
  ],
};
